import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import '@/styles/main.css';

const dsn = import.meta.env.VITE_SENTRY_DSN;
if (typeof dsn === 'string' && dsn.length > 0) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
  });
}

const rootElement = document.getElementById('root');

if (!rootElement) throw new Error('Root element is missing.');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
